// Osobnost, která vybrala megaslovo týdne (jen česká verze, 25. 10. 2026).
// Data přicházejí s /weekly/last_word (backend mega_osobnost.verejne) jen pro
// týden, ke kterému patří — s novým megaslovem box sám zmizí. Fotka jde
// rozkliknout do zvětšeniny (zavře se klikem kamkoli nebo Esc).
import { useEffect, useRef, useState } from "react";
import { SERVER_URL } from "./api";

export default function MegaOsobnostBox({ osobnost, t }) {
  const [velka, setVelka] = useState(false);
  const tlacitko = useRef(null);
  const okno = useRef(null);
  const otevreno = useRef(false);

  // Fokus do zvětšeniny a po zavření zpátky na fotku (klávesnice, čtečky).
  useEffect(() => {
    if (velka) {
      otevreno.current = true;
      okno.current?.focus();
      const esc = (e) => { if (e.key === "Escape") setVelka(false); };
      document.addEventListener("keydown", esc);
      return () => document.removeEventListener("keydown", esc);
    }
    if (otevreno.current) {
      otevreno.current = false;
      tlacitko.current?.focus();
    }
    return undefined;
  }, [velka]);

  if (!osobnost || !osobnost.jmeno) return null;
  const foto = osobnost.foto ? `${SERVER_URL}${osobnost.foto}` : null;
  // Jméno profilu z odkazu https://www.instagram.com/<jméno>/ — jen ten tvar se ukáže.
  const insta = (/^https:\/\/www\.instagram\.com\/([A-Za-z0-9._]+)\/$/.exec(osobnost.instagram || "") || [])[1];
  return (
    <div className="mega-osobnost" role="note">
      {foto && (
        <button
          ref={tlacitko}
          type="button"
          className="mega-osobnost__foto-btn"
          aria-label={t("mega.osobnost.zvetsit", { jmeno: osobnost.jmeno })}
          onClick={() => setVelka(true)}
        >
          <img className="mega-osobnost__foto" src={foto} alt="" loading="lazy" />
        </button>
      )}
      <div className="mega-osobnost__text">
        <span className="mega-osobnost__stitek">{t("mega.osobnost.stitek")}</span>
        <strong className="mega-osobnost__jmeno">{osobnost.jmeno}</strong>
        {osobnost.popis && <span className="mega-osobnost__popis">{osobnost.popis}</span>}
        {/* Server pustí jen https://www.instagram.com/<profil>/ (mega_osobnost.instagram_odkaz). */}
        {insta && (
          <a
            className="mega-osobnost__insta"
            href={osobnost.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t("mega.osobnost.instagram", { jmeno: osobnost.jmeno })}
          >
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" />
              <circle cx="12" cy="12" r="4.2" />
              <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
            </svg>
            <span>@{insta}</span>
          </a>
        )}
      </div>

      {velka && foto && (
        <div
          ref={okno}
          className="mega-osobnost__zvetsenina"
          role="dialog"
          aria-modal="true"
          aria-label={osobnost.jmeno}
          tabIndex={-1}
          onClick={() => setVelka(false)}
        >
          <figure>
            <img src={foto} alt={osobnost.jmeno} />
            <figcaption>{osobnost.jmeno}</figcaption>
          </figure>
        </div>
      )}
    </div>
  );
}
